import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type ScrollDownButtonSlots = {
  root: NonNullable<Slot<'button'>>;
  // This is the spinner that rotates
  spinner?: Slot<'svg'>;
  // This is the stroke that creates the spinner's full opacity section
  spinnerMaskStroke?: Slot<'circle'>;
  // Since SVG strokes are half inside the circle and out the circle, we add an extra circle to fill the background
  spinnerMaskBackground?: Slot<'circle'>;
  // Circle to apply the mask to
  spinnerBase?: Slot<'circle'>;
  // Icon to display
  icon: NonNullable<Slot<'span'>>;
};

/**
 * ScrollDownButton Props
 */
export type ScrollDownButtonProps = ComponentProps<Partial<ScrollDownButtonSlots>> & {
  isGenerating?: boolean;
};

/**
 * State used in rendering ScrollDownButton
 */
export type ScrollDownButtonState = ComponentState<ScrollDownButtonSlots> &
  Partial<Pick<ScrollDownButtonProps, 'isGenerating'>> & {
    maskId: string;
  };
